var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62891 7.40234C10.2852 6.71875 10.6875 5.79492 10.6875 4.7793V4.58008C10.6875 2.47852 8.9668 0.773438 6.8457 0.773438H1.06641C0.771484 0.773438 0.53125 1.01367 0.53125 1.30859V14.5723C0.53125 14.8906 0.789062 15.1484 1.10742 15.1484H7.33203C9.61719 15.1484 11.4688 13.3086 11.4688 11.0371V10.8223C11.4688 9.39648 10.7383 8.14062 9.62891 7.40234ZM2.40625 2.64844H6.79492C7.91016 2.64844 8.8125 3.51562 8.8125 4.58789V4.77344C8.8125 5.84375 7.9082 6.71289 6.79492 6.71289H2.40625V2.64844ZM9.56641 11.0352C9.56641 12.2637 8.55664 13.2598 7.31055 13.2598H2.40625V8.59961H7.31055C8.55664 8.59961 9.56641 9.5957 9.56641 10.8242V11.0352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.7faeac23.svg";
export { ForwardRef as ReactComponent };